import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import TopMenu from './topMenu/TopMenu';
import * as css from './Layout.css';
import EventMenu from './eventMenu/EventMenu';
import {useParams, Outlet} from 'react-router-dom';
import Navigation from '../layout/navigation/Navigation';
import {EXCLUDE_PACKAGE_SUPPORT, REACT_APP_ENV} from '../config/config';
import SupportComponent from './supportComponent/SupportComponent';
import AppComponent from '../pages/components/appComponent/AppComponent';
import BoxofficeIframe from './boxofficeIframe/BoxofficeIframe';
import useTablet from '../hooks/useTablet';
import setGlobalState from '../redux/setGlobalState';
import store from '../store';
import {updateDesignPop} from '../redux/event/eventActions';
import {useTranslation} from 'react-i18next';
import useQuery from '../hooks/useQuery';
import {PageWrapperContext} from '../pages/components/pageWrapper/PageWrapper';
import SubMenu from '../pages/components/subMenu/SubMenu';
import useWideScreen from '../hooks/useWideScreen';
export const openDesignPop=()=>{
    const event = store.getState().event;
    const eid = REACT_APP_ENV==='production'?47110:35849;
    const isShowDesignPop=(event.eid>eid)||REACT_APP_ENV==='local';
    if(!event.showPop && event.previewLastUpdate && event.type==='ticket'&&isShowDesignPop){
        setGlobalState('ui.show.isOpenDesignPop',true);
        if(!event.showPop)
            updateDesignPop().then();
    }
};

function Layout() {
    const account = useSelector(state => state.account);
    const event = useSelector(state => state.event);
    const {eid, pid, page, subPage} = useParams();
    const eidParam = eid;
    const pidParam = pid;
    const [miniMenu, setMiniMenu] = useState(0);
    const [form, setForm] = useState(0);
    const isTablet = useTablet();
    const oldSystem = useSelector(s => s.realtime.user.oldSystem);
    const {t} = useTranslation('layout');
    const query = useQuery();
    const packagePage = query.get('packagePage');
    const boxOffice  = query.get('boxOffice');
    const iframeDisplayFromState = useSelector(s => s.ui.layout.iframeDisplay);

    useEffect(() => {
        if(page==='design'&& event.eid&& !event.updateDesignPopXHR)
            openDesignPop();
    }, [page,event.eid]);

    useEffect(() => {
        if(page!=='realtime')
            setGlobalState('realtime.user.oldSystem', false);
    }, [page]);

    const [positionValue, setPositionValue] = useState('');

    const setPosition = (value) => {
        setPositionValue(value);
    };

    const userMessageShow = useSelector((state) => state.ui.userMessage.text);
    const isWideScreen = useWideScreen();
    const isSubscriptions = page === 'subscription' && isWideScreen;
    const isRealtime = page === 'realtime' && !oldSystem && (['ticket', 'area','givechak','subscription'].includes(event.type));// || (['givechak'].includes(event.type) && isMaster())

    const routeType = eid ? 'event' : pid ? 'package' : '';
    const title = packagePage ? `Tickchak | ${packagePage} - ${t('package', {lng: 'he'})} ${t(packagePage, {lng: 'he'})}`
        : boxOffice ? `Tickchak | boxOffice -  ${t('boxOffice', {lng: 'he'})}`:
            page
                ? (page === 'attendance' &&  subPage ? `Tickchak | ${page} - ${t(page, {lng: 'he'})} מפגש ספציפי`
                    :`Tickchak | ${page}${subPage ? `/${subPage}` : ''} - ${t(routeType, {lng: 'he'})} ${t(page, {lng: 'he'})}${subPage ? `/${t(subPage, {lng: 'he'})}` : ''}`)
                : 'Tickchak';
    return (
        <>
            <title>{title}</title>
            <BoxofficeIframe/>
            <css.layout id='layout' $marginValue={positionValue} className={`${userMessageShow && ' show'} ${iframeDisplayFromState && 'iframeDisplay'}`}>
                <>
                    <TopMenu updateLayout={setPosition}/>
                    <css.layoutContent>
                        {(!isTablet && event.eid && (event.ready === 5 || event.ready === 4)) &&
                            <EventMenu updateMiniMenu={(mini) => setMiniMenu(mini)}/>}
                        <css.layoutContentFrame
                            className={((event && event.ready < 4) && 'build ') + (form && ' form ') + (event && ' event')}
                            mini={miniMenu}
                            $realtime={isRealtime || isSubscriptions}
                            $subscriptions={isSubscriptions}>
                            {(eidParam && (!isRealtime)) && <Navigation/>}
                            <css.MyComponent className={`${userMessageShow && 'stop-click'} ${pidParam && 'account'}`}>
                                <Outlet />
                            </css.MyComponent>
                        </css.layoutContentFrame>
                    </css.layoutContent>
                </>
                {!EXCLUDE_PACKAGE_SUPPORT.includes(account?.pid) && <SupportComponent/>}
                {(eid && iframeDisplayFromState) && <PageWrapperContext.Provider value={{operations: undefined}}>
                    <SubMenu image={undefined} className={undefined} openLeft={undefined} routing={undefined} subMenuProps={undefined} mobileActions={[]}>
                        {undefined}
                    </SubMenu>
                </PageWrapperContext.Provider>}
            </css.layout>
            <AppComponent setForm={setForm}/>
        </>
    );
}

export default Layout;
